import { createConfigExperiment, getExperiment } from '@pegasus/abtesting';
import { useSelector } from 'react-redux';

export const PROJECT_ID = '53266602-b8f2-4df5-a1ab-d5d3007ff795';
export const CONTROL_A = 'smartbanner_off';
export const VARIANT_B = 'smartbanner_on';

export const useSmartBanner = () => {
    // @ts-ignore
    const experiment = useSelector(state => getExperiment(state, PROJECT_ID));
    if (!experiment) {
        return false;
    }

    // @ts-ignore
    return experiment?.variant === VARIANT_B;
};

export default createConfigExperiment({
    projectId: PROJECT_ID,
    variants: [CONTROL_A, VARIANT_B],
});
